module.exports = __webpack_public_path__ + "img/miao_coin.f8364a1c.svg";